import React from "react";
import {} from "reactstrap";
const FooterSection = () => {
  return (
    <>
      <footer className="footer-bg text-center text-white fixed-bottom p-1 container commonFont ">
        Made with 💖
      </footer>
    </>
  );
};

export default FooterSection;
